import { Config } from './types'

const plusMinusConfig: { [key: string]: Config } = {
  '1': {
    minNumerator: 2,
    maxNumerator: 8,
    minDenominator: 2,
    maxDenominator: 10,
    maxVariation: 4,
  },
  '2': {
    minNumerator: 2,
    maxNumerator: 18,
    minDenominator: 10,
    maxDenominator: 20,
    maxVariation: 7,
  },
  '3': {
    minNumerator: 2,
    maxNumerator: 96,
    minDenominator: 10,
    maxDenominator: 98,
    maxVariation: 30,
  },
}
/**
 *
 * @param difficultyLevel
 * @returns configuration object based on difficulty level
 */
export function getRangesByDifficulty(difficultyLevel: number): Config {
  return plusMinusConfig[difficultyLevel] || plusMinusConfig[1]
}
